/* https://codesandbox.io/s/multiselect-checkboxes-oennn */
import React, { PureComponent } from "react";
import styles from './css/MaterialList.module.scss';
import Dialog from 'react-a11y-dialog';
import MVGranite from './images/Detail_MockUp_MVGranite.png'
import legendGWP from './images/k-04.png'
import legendMBEnvelope from './images/MaterialBreakdown-11.png'
import legendMBFlooring from './images/System_Boundary-flooring_EDIT.png'
import legendMBCelings from './images/ceilingslegendaxon.png'
import legendMBPartitions from './images/System_Boundary-partitions.png'
import legendMBWall from './images/System_Boundary-wallfinishes.png' 
import legendMBInsulation from './images/System_Boundary-wallfinishes.png' 
import { SYSTEM_TYPE_FLOORING, SYSTEM_TYPE_CEILINGS, SYSTEM_TYPE_PARTITIONS, SYSTEM_TYPE_ENVELOPES, SYSTEM_TYPE_WALL, SYSTEM_TYPE_INSULATION } from './CommonUtil';
import Checkbox from './Checkbox'
import Pie from "./PieChart";
import 'pretty-checkbox'
import { UNIT_PRESETS } from "./Units";


let myImg;
let legend;
let legendText = "hello";


let colsEnvelope = ["#c8e3b6", "#74deb6", "#bfe6b1", "#74deb6", "#bfe6b1", "#74deb6", "#74deb6", "#74deb6", "#74deb6", "#74deb6", "#74deb6", "#74deb6", "#b6e6e9", "#bfe6b1", "#74deb6", "#93cee6", "#2461fa", "#2461fa", "#2461fa", "#74deb6", "#74deb6", "#bfe6b1", "#74deb6", "#bfe6b1", "#74deb6", "#93cee6", "#93cee6", "#b6e6e9", "#74deb6", "#74deb6", "#bfe6b1", "#bfe6b1", "#bfe6b1", "#93cee6", "#0087fb", "#2461fa", "#2461fa", "#00177b", "#ffe2b9", "#ffb65b", "#ffb65b", "#ffb65b", "#c5c5c5", "#aaaaaa", "#c5c5c5", "#aaaaaa", "#8e8e8e", "#5b5b5b", "#2d2d2d"]
const materialNamesEnvelope = ["mat49", "mat48", "mat47", "mat46", "mat45", "mat44", "mat43", "mat42", "mat41", "mat40", "mat39", "mat38", "mat37", "mat36", "mat35", "mat34", "mat33", "mat32", "mat31", "mat30", "mat29", "mat28", "mat27", "mat26", "mat25", "mat24", "mat23", "mat22", "mat21", "mat20", "mat19", "mat18", "mat17", "mat16", "mat15", "mat14", "mat13", "mat12", "mat11", "mat10", "mat9", "mat8", "mat7", "mat6", "mat5", "mat4", "mat3", "mat2", "mat1"];
let materialLabelEnvelope = { mat1: "Paint, interior acrylic latex", mat2: "Wall board, gypsum, natural", mat3: "Cold formed structural steel", mat4: "Fiberglass mat gypsum sheathing board", mat5: "Self-adhering, polymer-modified asphalt sheet underlayment", mat6: "Aluminum Backpan", mat7: "Powder coating, metal stock", mat8: "Mineral wool, low density, NAIMA - EPD", mat9: "Spray polyurethane foal, closed cell, (HFO blowing agent)", mat10: "XPS insulation, Foamular average, Owens Corning - EPD", mat11: "Polyureathane foam (PUR) rigid board", mat12: "Adhesive, polychloroprene (neoprene)", mat13: "Galvanized steel", mat14: "Galvanized steel support", mat15: "Aluminum extrusion, AEC - EPD", mat16: "Fasteners, stainless steel", mat17: "Mortar type S", mat18: "Mortar type N", mat19: "Aluminum sheet", mat20: "Stone slab, granite", mat21: "Stone slab, limestone", mat22: "Cement bonded particle board", mat23: "Steel Sheet", mat24: "Zinc coating (galvanized) for stee G60", mat25: "Brick, generic", mat26: "Fluoropolymer coating, metal stock", mat27: "Steel insulated metal panel (IMP), MCA - EPD", mat28: "Glass fiber board, NAIMA - EPD", mat29: "Stucco synthetic", mat30: "Structural concrete, 5000 psi, 0% fly ash and slag", mat31: "Aluminum curtain wall system, YKK AP - EPD ", mat32: "Stainless steel, extruded chromium 18/8", mat33: "Glue laminated timber (Glulam), AWC - EPD", mat34: "Argon gas for IGU", mat35: "Glazing, monolithic sheet, tempered", mat36: "IGU spacer", mat37: "Low-e coating (for glazing)", mat38: "GFRC panel, Rieder, FibreC panel - EPD", mat39: "GFRC", mat40: "Aluminum-faced composite wall panel (ACM), MCA - EPD", mat41: "Terracotta", mat42: "Phenolic resin solid surfacing, sheet", mat43: "Fiber cement board", mat44: "Titanium zinc sheet, Rheinzink, prePATINA blue/graphite-grey - EPD", mat45: "Paint, enamel, solvent based", mat46: "Steel, sheet", mat47: "Wood stain, water based", mat48: "Tulipwood lumber, 1 inch", mat49: "Steel, welded wire mesh" };


let colsFlooring = ["#c7e9b7", "#c7e9b7", "#b5e2bd", "#85E2BD", "#85E2BD", "#85E2BD", "#85E2BD", "#85E2BD", "#89EFC0", "#85E2BD", "#85E2BD", "#85E2BD", "#85E2BD", "#85E2BD", "#85E2BD", "#85E2BD", "#85E2BD", "#85E2BD", "#0090ff", "#0090ff", "#0090ff", "#B3B3B3", "#B3B3B3", "#cccccc", "#cccccc", "#999999", "#666666"]
const materialNamesFlooring = ["mat27", "mat26", "mat25", "mat24", "mat23", "mat22", "mat21", "mat20", "mat19", "mat18", "mat17", "mat16", "mat15", "mat14", "mat13", "mat12", "mat11", "mat10", "mat9", "mat8", "mat7", "mat6", "mat5", "mat4", "mat3", "mat2", "mat1"];
let materialLabelFlooring = { mat1: "Polyethelene sheet vapor barrier", mat2: "Interior grade plywood", mat3: "Cement grout", mat4: "Cement mortar", mat5: "Self-leveling underlayment", mat6: "Thickset mortar", mat7: "Fasteners, galvanized steel", mat8: "Floor adhesive, carpet", mat9: "Floor adhesive, latex", mat10: "Bamboo plank", mat11: "Ceramic tile, glazed", mat12: "Commercial high-traffic carpet, high pile", mat13: "Commercial high-traffic carpet, low pile", mat14: "Commercial high-traffic carpet, medium pile", mat15: "Cork tile", mat16: "Domestic softwood", mat17: "Granite tile", mat18: "Hardwood veneer, thick", mat19: "Homogeneous vinyl tile", mat20: "Linoleum tile", mat21: "SBS rubber tile", mat22: "Slate tile", mat23: "White oak lumber, 1 inch", mat24: "Terrazzo", mat25: "Epoxy", mat26: "Wood sealer, water-based", mat27: "Polyurethane floor finish" };

let colsCeilings = [ "#CCCCCC", "#666666", "#999999", "#666666", "#C2EAA7", "#C2EAA7", "#89EFC0", "#89EFC0", "#C2EAA7", "#FEE6BF", "#FCC05E", "#C2EAA7", "#89EFC0", "#89EFC0", "#89EFC0", "#89EFC0", "#C2EAA7", "#89EFC0", "#89EFC0", "#89EFC0", "#5CBDFF", "#00AAFF", "#4169E1", "#5CBDFF", "#000099" ];
let materialNamesCeilings = ["mat25", "mat24", "mat23", "mat22", "mat21", "mat20", "mat19", "mat18", "mat17", "mat16", "mat15", "mat14", "mat13", "mat12", "mat11", "mat10", "mat9", "mat8", "mat7", "mat6", "mat5", "mat4", "mat3", "mat2", "mat1"]; 
let materialLabelCeilings = { mat1: "Steel, cable", mat2: "Suspended grid", mat3: "Cold formed structural steel", mat4: "Fasteners, galvanized steel", mat5: "Galvanized steel", mat6: "Acoustic ceiling tile (ACT), fiberglass", mat7: "Acoustic ceiling tile (ACT), mineral fiber board", mat8: "Acoustic ceiling tile (ACT), perforated aluminum", mat9: "Aluminum extrusion, AEC - EPD", mat10: "Aluminum, formed", mat11: "Ceiling tile, aluminum", mat12: "K-13 Spray on System", mat13: "Tulipwood lumber, 1 inch", mat14: "Medium density fiberboard (MDF), AWC - EPD", mat15: "Adhesive, polyurethane", mat16: "Hardwood veneer, medium thickness", mat17: "Hard maple lumber, 1 inch", mat18: "Wall board, gypsum, moisture- and mold-resistant", mat19: "Wall board, gypsum, natural", mat20: "Walnut lumber, 1 inch", mat21: "Paint, interior acrylic latex", mat22: "Paint, enamel, solvent based", mat23: "Polyurethane top coat, water-based, for wood", mat24: "Powder coating, metal stock", mat25: "Wood stain, water based" }; 

let colsPartitions = [ "#666666","#666666","#89EFC0","#89EFC0","#C2EAA7","#89EFC0","#FFB65B","#FFB65B","#FFB65B","#FFB65B","#5CBDFF","#C1E9EC","#87CEE9","#8BD3F7","#5CBDFF","#4169E1","#4169E1","#4169E1","#000099","#000099","#000099","#000099"];
let materialNamesPartitions = ["mat22", "mat21", "mat20", "mat19", "mat18", "mat17", "mat16", "mat15", "mat14", "mat13", "mat12", "mat11", "mat10", "mat9", "mat8", "mat7", "mat6", "mat5", "mat4", "mat3", "mat2", "mat1"]; 
let materialLabelPartitions = {mat1:"Coated non-structural steel framing, ClarkDietrich, ProSTUD - EPD", mat2:"Domestic softwood, US, AWC - EPD", mat3:"Concrete masonry unit (CMU), hollow-core", mat4:"Jandris Block CarbonX Normal Weight - EPD", mat5:"Aluminum curtain wall system, YKK AP - EPD ", mat6:"White oak lumber, 2 inch", mat7:"Steel, reinforcing rod", mat8:"Thickset mortar", mat9:"Mortar type N", mat10:"Cold formed structural steel", mat11:"Galvanized steel", mat12:"Sealant, silicone", mat13:"Mineral wool, low density, NAIMA - EPD", mat14:"Polyurethane foam (PUR) rigid board", mat15:"Glass wool unfaced batt, Knauf, EcoBatt - EPD", mat16:"Cellulose insulation, boards", mat17:"Wall board, gypsum, fire-resistant (Type X)", mat18:"Glazing, monolithic sheet, tempered", mat19:"Medium density fiberboard (MDF), AWC - EPD", mat20:"EcoSmart Firecode X Gypsum - EPD", mat21:"Paint, interior acrylic latex", mat22:"Wood stain, water based, by area"}; 


let colsWall = [ "#999999","#999999","#CCCCCC","#F59E46","#F59E46","#FEE6BF","#89EFC0","#89EFC0","#89EFC0","#FBC05D","#FBC05D","#89EFC0","#C2EAA7","#C2EAA7","#C2EAA7","#70BF51","#89EFC0","#89EFC0","#89EFC0","#89EFC0","#89EFC0","#89EFC0","#89EFC0","#C2EAA7","#89EFC0","#89EFC0","#89EFC0","#89EFC0","#89EFC0","#89EFC0","#89EFC0","#89EFC0","#89EFC0","#000099","#000099","#000099","#000099","#4169E1","#000099"];
let materialNamesWall = ["mat39", "mat38", "mat37", "mat36", "mat35", "mat34", "mat33", "mat32", "mat31", "mat30", "mat29", "mat28", "mat27", "mat26", "mat25", "mat24", "mat23", "mat22", "mat21", "mat20", "mat19", "mat18", "mat17", "mat16", "mat15", "mat14", "mat13", "mat12", "mat11", "mat10", "mat9", "mat8", "mat7", "mat6", "mat5", "mat4", "mat3", "mat2", "mat1"]; 
let materialLabelWall = {mat1: "Interior grade plywood, US, AWC - EPD",mat2: "Aluminum, cast",mat3: "Cement mortar, Latricrete - EPD",mat4: "Cement mortar, TCNA - EPD",mat5: "Domestic softwood, US, AWC - EPD",mat6: "Underlayment, fibrous",mat7: "Acrylic solid surface (acrylic polymer and ATH)",mat8: "Anodized aluminum, sheet",mat9: "Bamboo plank",mat10: "Cork tile",mat11: "Paint, interior acrylic latex",mat12: "Porcelain ceramic tile, glazed",mat13: "Stainless steel sheet, Chromium 18/8",mat14: "Wall covering, wallpaper",mat15: "Wall covering, textile",mat16: "Cement grout, TCNA - EPD",mat17: "Aluminum, sheet",mat18: "Tectum Ceiling+Wall Panels - EPD",mat19: "Wallcoverings on Non-Woven Base - EPD",mat20: "Archisonic  Acoustic PET  Panel, 12 mm",mat21: 'Acrovyn Wall Covering Sheet, 0.060" - EPD',mat22: "Wall covering, vinyl",mat23: "Cosentino Dekton - EPD",mat24: "Tulipwood lumber, 2 inch",mat25: "Interior grade plywood, US, AWC - EPD",mat26: "Particleboard, AWC - EPD",mat27: "Medium density fiberboard (MDF), AWC - EPD",mat28: "Armstrong WoodWorks ACGI Flat Panels: SS1, SS2, SS3, SS4 - EPD",vmat29: "Adhesive, latex",mat30: "Adhesive, polychloroprene (neoprene)",mat31: "Steel, sheet",mat32: "High pressure laminate (HPL)",mat33: "Hardwood veneer, medium thickness",mat34: "Adhesive, polyurethane",mat35: "Tulipwood lumber, 1 inch",mat36: "Polycarbonate, cellular, sheet good",mat37: "Wood stain, water based",mat38: "Powder coating, metal stock",mat39: "Polyurethane top coat, water-based, for wood" }; 


let colsInsulation = [ "#89EFC0","#C2EAA7","#89EFC0","#89EFC0","#89EFC0","#89EFC0","#89EFC0","#89EFC0","#89EFC0","#89EFC0","#89EFC0","#000099","#000099","#000099","#000099","#4169E1","#000099"];
let materialNamesInsulation = ["mat17", "mat16", "mat15", "mat14", "mat13", "mat12", "mat11", "mat10", "mat9", "mat8", "mat7", "mat6", "mat5", "mat4", "mat3", "mat2", "mat1"]; 
let materialLabelInsulation = {mat1: "Interior grade plywood, US, AWC - EPD",mat2: "Aluminum, cast",mat3: "Cement mortar, Latricrete - EPD",mat4: "Cement mortar, TCNA - EPD",mat5: "Domestic softwood, US, AWC - EPD",mat6: "Underlayment, fibrous",mat7: "Acrylic solid surface (acrylic polymer and ATH)",mat8: "Anodized aluminum, sheet",mat9: "Bamboo plank",mat10: "Cork tile",mat11: "Paint, interior acrylic latex",mat12: "Porcelain ceramic tile, glazed",mat13: "Stainless steel sheet, Chromium 18/8",mat14: "Wall covering, wallpaper",mat15: "Wall covering, textile",mat16: "Cement grout, TCNA - EPD",mat17: "Aluminum, sheet" };


export default class MaterialList extends PureComponent {

  constructor(props) {


    super(props);

    this.legendMB = legendMBEnvelope;
    if (props.type === SYSTEM_TYPE_FLOORING) {
      this.legendMB = legendMBFlooring;
    }
    if(props.type === SYSTEM_TYPE_CEILINGS) {
      this.legendMB = legendMBCelings;
    }
    if(props.type === SYSTEM_TYPE_PARTITIONS) {
      this.legendMB = legendMBPartitions;
    }
    if(props.type === SYSTEM_TYPE_WALL) {
      this.legendMB = legendMBWall;
    }
    if(props.type === SYSTEM_TYPE_INSULATION) {
      this.legendMB = legendMBInsulation;
    }

    this.state = {
      items: props.materials.map(material => { return { label: material, id: material } }),
      selectedItems: props.initialSelectedMaterials,
      materialPopup: {
        name: "Material"
      },
      checked: true,
      curSel: 'tenYGWP',
      
      // ✅ 新增这一行：用于记录鼠标点击的 Y 坐标高度
      dialogTop: 100 
    };

    this.listEl = null;
    this.handleSelectItem = this.handleSelectItem.bind(this);
    this.navigateMaterial = this.navigateMaterial.bind(this);
    this.getNavList = this.getNavList.bind(this);

  }

  scrollDialogIntoView = () => {
  requestAnimationFrame(() => {
      const el = document.querySelector('#materialdetailsdialog .dialog-content');
      if (el) el.scrollIntoView({ block: 'center', inline: 'nearest' });
    });
  };


  selectChange = (e) => {
    this.setState({ curSel: e.target.value });
  };


  handleSelectItem(e) {
    const { value } = e.target;
    const nextValue = this.getNextValue(value);

    this.setState({ selectedItems: nextValue });
    this.props.updateSelectedMaterials(nextValue);
  }

  handleSelectAll(e) {
    this.setState({ selectedItems: this.props.materials});
    this.props.updateSelectedMaterials(this.props.materials);
  }



  // componentDidMount() {
  //   const isSelectAllClicked = localStorage.getItem('isSelectAllClicked');
  //   if (isSelectAllClicked === 'true') {
  //     this.setState({ isSelectAllClicked: true }, () => {
  //       const selectAllButton = document.querySelector('.select-all-button');
  //       selectAllButton.click();
  //     });
  //   }
  // }

  componentDidMount() {
    this._onDialogOverlayMouseDown = (e) => {
      // - 点击弹窗外任意位置关闭
      // - 但点击 Tab 切换、左右切换箭头、关闭按钮 不触发关闭

      const dialogEl = document.getElementById("materialdetailsdialog");
      if (!dialogEl) return;

      // react-a11y-dialog 用 aria-hidden 标记开/关（不同版本可能是 true/false 或字符串）
      const ariaHidden = dialogEl.getAttribute("aria-hidden");
      const isOpen = ariaHidden === null || ariaHidden === "false";
      if (!isOpen) return;

      // 1) 弹窗内容内部的任何点击都不关闭
      //    注意：不同版本里 id 可能挂在 base 或 overlay 上，所以这里优先找 .dialog-content
      const contentEl = dialogEl.querySelector(".dialog-content") || dialogEl;
      if (contentEl.contains(e.target)) return;

      // 2) 左右切换按钮、关闭按钮都不算“外部点击”
      if (e.target.closest(`.${styles.dialogNavBtn}`)) return;
      if (e.target.closest(".dialog-close")) return;
      if (e.target.closest("[data-a11y-dialog-hide]")) return; // 保险：a11y-dialog 的 close 通常带这个属性

      // 3) Tabs 切换区域也不算“外部点击”
      if (e.target.closest(".MuiTabs-root")) return;
      if (e.target.closest(".MuiTab-root")) return;
      if (e.target.closest('[role="tablist"]')) return;
      if (e.target.closest('[role="tab"]')) return;

      // 4) 其余任何地方 -> 关闭
      if (this.materialsDialogRef) this.materialsDialogRef.hide();
    };

    // capture=true：保证我们能先拿到事件；pointerdown 同时覆盖 mouse + touch
    document.addEventListener("pointerdown", this._onDialogOverlayMouseDown, true);
  }

  componentWillUnmount() {
    document.removeEventListener("pointerdown", this._onDialogOverlayMouseDown, true);
  }


  getNextValue(value) {
    const { selectedItems } = this.state;

    // if it's already in there, remove it, otherwise append it
    return selectedItems.includes(value)
      ? selectedItems.filter(item => item !== value)
      : [...selectedItems, value];
  }

  reRreshSelect(e){
    this.setState({selectedItems:[]});
    this.props.updateSelectedMaterials([]);
  }

  showMaterialsPopup(event, material) {
    event.preventDefault();
    event.stopPropagation();

    // --- 修改开始 ---
    let targetTop = 100; // 给个默认保底值

    if (this.listEl) {
      const rect = this.listEl.getBoundingClientRect();
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      // 计算列表顶部的绝对 Y 坐标
      // 减去 50px 是为了留一点呼吸空间，让它比列表稍微高一点点
      targetTop = rect.top + scrollTop - 50;
    }
    
    // 防止计算出负数（比如页面刚加载时）
    targetTop = Math.max(20, targetTop);
    // --- 修改结束 ---

    myImg = 'https://raw.githubusercontent.com/Payette/LCA-Dashboard/master/public/images/' + material.id.toLowerCase() + '.png';

    this.setState({
      materialPopup: {
        name: material.label
      },
      dialogTop: targetTop // 将计算好的“列表顶部位置”存入状态
    }, () => {
      this.materialsDialogRef.show();
    })
  }

  handleCheckboxChange = event => {
    this.setState({ checked: event.target.checked })
  }


  renderItems() {


    
    const { items, selectedItems } = this.state;
    return items.map(item => {
      const { id, label } = item;

      let materialColor = '#4d4d4f';

      if (this.props.currentSel === "GWP") {
        materialColor = this.props.metaData.materialColors[id] ? this.props.metaData.materialColors[id] : '#4d4d4f';
      }

      const materialType = this.props.metaData.materialType[id] ? this.props.metaData.materialType[id] : undefined;

      return (

        <li key={id} className={styles.material}>


          <label>
            <Checkbox
              caseStudyColor={materialColor}
              onChange={this.handleSelectItem}
              type="checkbox"
              checked={selectedItems.includes(id)}
              value={id}
              id={`item-${id}`}
              name="check"
            />

          </label>


          <button className={styles.moreInformationButton} onClick={event => this.showMaterialsPopup.bind(this)(event, item)}>
          <label
            className={`${styles.mLabel} ${styles.clickableName}`}
            htmlFor={`item-${id}`}
            title="Click for details"
          >
            {materialType}
          </label>
          </button>
        </li>
      );
    });
  }

  selectChange(e) {
    // this.state.curSel = e.target.value;
    this.setState({ curSel: e.target.value })

  }

  getNavList() {
    // 只在“已勾选的材料”里切换
    const list = (this.state.selectedItems && this.state.selectedItems.length > 0)
      ? this.state.selectedItems
      : this.props.materials;
  
    // 如果你想“全材料都能切换”，就用这一行替换上面 list 逻辑：
    // const list = this.props.materials;
  
    // 去重 + 过滤空值，避免偶发 bug
    return Array.from(new Set(list)).filter(Boolean);
  }
  
  navigateMaterial(step) {
    const list = this.getNavList();
    if (!list.length) return;
  
    const cur = this.state.materialPopup?.name;
    let idx = list.indexOf(cur);
  
    // 如果当前不在列表里，就从 0 开始
    if (idx === -1) idx = 0;
  
    const nextIdx = (idx + step + list.length) % list.length;
    const nextName = list[nextIdx];
  
    this.setState(
      { materialPopup: { name: nextName } },
      () => {
        // 弹窗通常已经开着，但加这一句不影响，反而更保险
        if (this.materialsDialogRef) this.materialsDialogRef.show();
      }
    );
  }
  

  colsForType(type) {
    if(type === SYSTEM_TYPE_FLOORING){
      return colsFlooring;
    }
    if(type === SYSTEM_TYPE_CEILINGS) {
      return colsCeilings;
    }
    if(type === SYSTEM_TYPE_PARTITIONS) {
      return colsPartitions;
    }
    if(type === SYSTEM_TYPE_WALL) {
      return colsWall;
    }
    if(type === SYSTEM_TYPE_INSULATION) {
      return colsInsulation;
    }
    return colsEnvelope;
  }

  namesForType(type) {
    if(type === SYSTEM_TYPE_FLOORING){
      return materialNamesFlooring;
    }
    if(type === SYSTEM_TYPE_CEILINGS) {
      return materialNamesCeilings;
    }
    if(type === SYSTEM_TYPE_PARTITIONS) {
      return materialNamesPartitions;
    }
    if(type === SYSTEM_TYPE_WALL) {
      return materialNamesWall;
    }
    if(type === SYSTEM_TYPE_INSULATION) {
      return materialNamesInsulation;
    }

    return materialNamesEnvelope;    
  }

  labelForType(type) {
    if(type === SYSTEM_TYPE_FLOORING){
      return materialLabelFlooring;
    }
    if(type === SYSTEM_TYPE_CEILINGS) {
      return materialLabelCeilings;
    }
    if(type === SYSTEM_TYPE_PARTITIONS) {
      return materialLabelPartitions;
    }
    if(type === SYSTEM_TYPE_WALL) {
      return materialLabelWall;
    }
    if(type === SYSTEM_TYPE_INSULATION) {
      return materialLabelInsulation;
    }

    return materialLabelEnvelope;    
  }

  render() {
    const units = this.props.units || UNIT_PRESETS.SF;
    const isInsulationPopup = this.props.type === SYSTEM_TYPE_INSULATION;

    const isInsulation = this.props.type === SYSTEM_TYPE_INSULATION;

    const sectionIcons = (this.props.metaData && this.props.metaData.sectionIcons) ? this.props.metaData.sectionIcons : {};


    const notes = (this.props.metaData?.materialNotes?.[this.state.materialPopup?.name]) || [];
    const healthNotes = (this.props.metaData?.materialHealthNotes?.[this.state.materialPopup?.name]) || [];



    // console.log(this.props.currentSel);

    if (this.props.currentSel === "GWP") {
      legend = legendGWP;
      legendText = ""
    } else if (this.props.currentSel === "allImpacts") {
      legend = legendGWP;
      legendText = <div className={styles.serif} style={{fontSize: "0.95em" } }><p> <span style={{ background: "#87cee9" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Global Warming Potential (kgCO<sub>2</sub>eq{units.allImpactsSuffix})</p> <p> <span style={{ background: "#6495ed" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Non-Renewable Energy Demand (MJ{units.allImpactsSuffix})</p><p> <span style={{ background: "#fcc05e" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Eutrophication Potential (kgNeq{units.allImpactsSuffix})</p> <p> <span style={{ background: "#0090ff" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Smog Formation Potential (kgO<sub>3</sub>eq{units.allImpactsSuffix})</p><p> <span style={{ background: "#85e2bd" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Acidification Potential (kgSO<sub>2</sub>eq{units.allImpactsSuffix})</p> <p> <span style={{ background: "#283cdc" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Ozone Depletion Potential (CFC-11eq{units.allImpactsSuffix})</p></div>
    } else if (this.props.currentSel === "LCS") {
      legend = legendGWP;
      legendText = <div className={styles.serif}><p> <span style={{ background: "#85e2bd" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; [A1 - A3] Product </p> <p> <span style={{ background: "#fcc05e" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; [A4] Transportation </p><p> <span style={{ background: "#001489" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; [B2 - B5] Maintenance and Replacement </p> <p> <span style={{ background: "#4095ee" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; [C2 - C4] End of Life </p><p> <span style={{ background: "#a2d3eb" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; [D] Module D </p> </div>
    } else if (this.props.currentSel === "MB") {
      legend = this.legendMB;
      legendText = <div className={styles.serif}><img style={{ maxWidth: "320px" }} src={legend} /><p> <span style={{ background: "#85e2bd" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Exterior Finish </p> <p> <span style={{ background: "#4169e1" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Support System </p> <p> <span style={{ background: "#fcc05e" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Insulation </p> <p> <span style={{ background: "#cccccc" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Other </p></div>
      if (this.props.type === SYSTEM_TYPE_FLOORING) {
        legendText = <div className={styles.serif}><img style={{ maxWidth: "320px" }} src={legend} /><p> <span style={{ background: "#85e2bd" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Flooring Finish </p> <p className={styles.serif}> <span style={{ background: "#4169e1" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Attachment Material </p> <p> <span style={{ background: "#cccccc" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Other </p></div>
      }
      if (this.props.type === SYSTEM_TYPE_CEILINGS) {
        legendText = <div className={styles.serif}>
          <img style={{ maxWidth: "320px" }} src={legend} />
            <p><span style={{ background: "#4169e1" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Support System </p>
            <p className={styles.serif}> <span style={{ background: "#85e2bd" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Finish Material </p>
            <p> <span style={{ background: "#cccccc" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Surface Treatment </p>
        </div>
      }
      if (this.props.type === SYSTEM_TYPE_PARTITIONS) {
        legendText = <div className={styles.serif}>
          <img style={{ maxWidth: "320px" }} src={legend} />
            <p><span style={{ background: "#4169e1" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Support System </p>
            <p> <span style={{ background: "#fcc05e" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Insulation </p> 
            <p className={styles.serif}> <span style={{ background: "#85e2bd" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Finish Material </p>
            <p> <span style={{ background: "#cccccc" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Surface Treatment </p>
        </div>
      }
      if (this.props.type === SYSTEM_TYPE_WALL) {
        legendText = <div className={styles.serif}>
          <img style={{ maxWidth: "320px" }} src={legend} />
            <p><span style={{ background: "#4169e1" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Support System </p>
            <p className={styles.serif}> <span style={{ background: "#85e2bd" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Finish Material </p>
            <p> <span style={{ background: "#cccccc" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Surface Treatment </p>
        </div>
      }
      if (this.props.type === SYSTEM_TYPE_INSULATION) {
        legendText = <div className={styles.serif}>
          <img style={{ maxWidth: "320px" }} src={legend} />
            <p><span style={{ background: "#4169e1" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Support System </p>
            <p className={styles.serif}> <span style={{ background: "#85e2bd" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Finish Material </p>
            <p> <span style={{ background: "#cccccc" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Surface Treatment </p>
        </div>
      }      
    } else if (this.props.currentSel === "MH") {
      legend = this.legendMB;
      legendText = <div className={styles.serif} style={{fontSize: "0.90em" } }>
      <p> <span style={{ background: "#00a558" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Meets Payette Material Health Policy </p>
      <p> <span style={{ background: "#8cc672" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Meets Payette Material Health Policy with Requests </p> 
      <p> <span style={{ background: "#FEBE10" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Meets some of Payette Material Health Policy </p>
      <p> <span style={{ background: "#D51C29" }}> &nbsp; &nbsp; &nbsp; </span> &nbsp; Does not meet Payette Material Health Policy </p></div>
    }

    let sectionImg = this.props.metaData.sectionIcons[this.state.materialPopup.name];
    let concatNotes = [];
    concatNotes = this.props.metaData.materialNotes[this.state.materialPopup.name];

    let listItems;
    if (this.state.materialPopup.name !== "Material") {
      listItems = this.props.metaData.materialNotes[this.state.materialPopup.name].map((number) =>
        <li>- {number}</li>
      );
    }

    let listItemsHealth;
    if (this.props.hasMaterialHealth) {
      if (this.state.materialPopup.name !== "Material") {
        listItemsHealth = this.props.metaData.materialHealthText[this.state.materialPopup.name].map((number) =>
          <li>- {number}</li>
        );
      }
    }

    const pieW = Math.min(520, Math.round(window.innerWidth * 0.4));
    const pieH = Math.round(pieW * 0.8);
    


    return (
      <>
        <div>
          {legendText && <>
            <h3>LEGEND</h3>
            <span>
              {legendText}
              {/* <img style={{maxWidth: "100%", maxHeight: "100%"}} src={legend}/> */}<br></br>
            </span>
          </>}
          <div>
            <div style={{ whiteSpace: 'nowrap' }}>
              <h3 style={{ display: "inline-block", marginBottom: "0.5em", textTransform: "uppercase" }}>{this.props.title}</h3>
              <button className={styles.mButton} onClick={e => this.handleSelectAll.bind(this)(e)}>Select All</button>
              <button className={styles.mButton} onClick={e => this.reRreshSelect.bind(this)(e)}>Clear</button>
            </div>
            <div className={styles.sansserif} style={{ fontWeight: "bold", marginBottom: "0.75em", fontSize: "0.9em" }}>Click on type name below for additional details</div>
          </div>


          <ul className={styles.container} ref={node => (this.listEl = node)}>{this.renderItems()}
          </ul>
        </div>
        
        <Dialog
          id="materialdetailsdialog"
          appRoot="#root"
          dialogRoot="#dialog-root"
          dialogRef={(dialog) => (this.materialsDialogRef = dialog)}
          classNames={{
            overlay: "dialog-overlay",
            closeButton: "dialog-close",
            element: isInsulationPopup
              ? "dialog-content dialog-content--compact dialog-content--scaled"
              : "dialog-content dialog-content--scaled",
            base: isInsulationPopup ? "dialog dialog--compact" : "dialog"
          }}
        >

            {/* ✅ 终极坐标锁定代码：将动态计算的高度注入，并解除所有被绑架的坐标系 */}
          <style>
            {`
              /* 1. 强制重置根容器 */
              #dialog-root {
                position: static !important; 
              }

              /* 2. 弹窗外框：取消 Flex 居中，改为块级布局，确保坐标完全由我们控制 */
              #materialdetailsdialog.dialog {
                position: absolute !important;
                top: 0 !important;
                left: 0 !important;
                right: 0 !important;
                bottom: 0 !important;
                display: block !important; /* 改为 block，不再用 flex */
                pointer-events: none;
              }

              /* 3. 背景遮罩 */
              #materialdetailsdialog .dialog-overlay {
                position: absolute !important;
                inset: 0 !important;
                background: rgba(255,255,255,0.0); /* 保持透明或半透明 */
              }

              /* 4. 弹窗本体：使用 top 进行绝对定位 */
              #materialdetailsdialog .dialog-content {
                position: absolute !important;
                left: 50% !important;
                transform: translateX(-50%) !important; /* 水平居中 */
                
                /* 核心：使用我们在 showMaterialsPopup 里计算出的“列表顶部”高度 */
                top: ${this.state.dialogTop}px !important; 
                margin: 0 !important; /* 清除默认 margin */
                
                pointer-events: auto;
              }
            `}
          </style>

          {/* 外层包一层用于定位 */}
          <div className={styles.dialogBody}>

            {/* 不占布局，用 absolute 悬浮 */}
            <button
              type="button"
              className={`${styles.dialogNavBtn} ${styles.dialogNavLeft}`}
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.navigateMaterial(-1); }}
              aria-label="Previous material"
              title="Previous"
            >
              ‹
            </button>

            <button
              type="button"
              className={`${styles.dialogNavBtn} ${styles.dialogNavRight}`}
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.navigateMaterial(1); }}
              aria-label="Next material"
              title="Next"
            >
              ›
            </button>
            <span>
              <h2 style={{ fontSize: "40px" }}>
                {this.props.metaData.materialName2[this.state.materialPopup.name]}
              </h2>

              {isInsulationPopup ? (
                //  INSULATION：只显示文字（不显示 radio / hover / pie / section 图）
                <div style={{ maxWidth: "100%", position: "relative" }}>
                  {this.state.materialPopup.name !== "Material" && (
                    <>
                      <div style={{ display: "block" }}>
                        <h4>Assumptions</h4>
                        <ul style={{ lineHeight: "1.4em", paddingLeft: "1em" }}>
                          {listItems}
                        </ul>
                      </div>

                      {this.props.hasMaterialHealth && (
                        <div style={{ position: "relative", display: "block" }}>
                          <h4>Material Health</h4>
                          <ul style={{ lineHeight: "1.4em", paddingLeft: "1em" }}>
                            {listItemsHealth}
                          </ul>
                        </div>
                      )}
                    </>
                  )}
                </div>
              ) : (
                //  其他系统：保留你原来的完整弹窗
                <>
                  {!isInsulation && (

                    <div className={styles.inlineOptions}>

                      <h4 >CHART TYPE</h4>

                      <label>
                        <input
                          type="radio"
                          name="lifeSpanModal"
                          value="tenYGWP"
                          checked={this.state.curSel === "tenYGWP"}
                          onChange={this.selectChange.bind(this)}
                        />
                        <span>Initial Carbon (Module A w/ biogenic CO2)</span>
                      </label>

                      <label>
                        <input
                          type="radio"
                          name="lifeSpanModal"
                          value="sixty2YGWP"
                          checked={this.state.curSel === "sixty2YGWP"}
                          onChange={this.selectChange.bind(this)}
                        />
                        <span>60 Year (w/ Module D &amp; biogenic CO2)</span>
                      </label>

                      <label>
                        <input
                          type="radio"
                          name="lifeSpanModal"
                          value="sixty1YGWP"
                          checked={this.state.curSel === "sixty1YGWP"}
                          onChange={this.selectChange.bind(this)}
                        />
                        <span>60 Year (no Module D &amp; no biogenic CO2)</span>
                      </label>

                    </div>
                  )}



                  <p
                    id="textLabel"
                    style={{
                      display: "block",
                      width: "100%",
                      position: "relative",
                      textAlign: "left",
                    }}
                  >
                    Hover over chart to see data
                  </p>
                  <br />

                  <div style={{ width: "30%", float: "left", position: "relative", textAlign: "center" }}>
                    <Pie
                      style={
                        this.props.type === SYSTEM_TYPE_ENVELOPES
                          ? { width: "100%", transform: "scaleX(-1)", zIndex: "-1", marginLeft: "3em" }
                          : { width: "100%", transform: "scaleX(-1)", zIndex: "-1", marginLeft: "3em", position: "absolute" }
                      }
                      width={pieW}
                      height={pieH}
                      matBreakdown={this.props.matBreakdown}
                      matBreakdown1={this.props.matBreakdown1}
                      matBreakdown2={this.props.matBreakdown2}
                      currentMat={this.state.materialPopup.name}
                      tenYGWP={this.props.tenYGWP}
                      sixty1YGWP={this.props.sixty1YGWP}
                      sixty2YGWP={this.props.sixty2YGWP}
                      GWPSel={this.state.curSel}
                      cols={this.colsForType(this.props.type)}
                      materialNames={this.namesForType(this.props.type)}
                      materialLabel={this.labelForType(this.props.type)}
                      gwpUnit={units.gwpUnit}
                    />
                  </div>

                  {this.props.type === SYSTEM_TYPE_ENVELOPES ? (
                    <>
                      <img
                        style={{ maxWidth: "40%", top: "-20%", position: "relative", float: "right", objectFit: "cover", display: "block" }}
                        src={sectionImg}
                        alt={`${this.state.materialPopup.name} facade diagram`}
                      />
                      <div style={{ maxWidth: "55%", float: "left", position: "relative" }}>
                        <h4>Assumptions</h4>
                        <ul style={{ lineHeight: "1.4em", paddingLeft: "1em" }}>{listItems}</ul>
                      </div>
                    </>
                  ) : (
                    <>
                      <img
                        style={{ maxWidth: "45%", top: "-70px", position: "relative", float: "right", objectFit: "cover", display: "block" }}
                        src={sectionImg}
                        alt={`${this.state.materialPopup.name} facade diagram`}
                      />
                      <div style={{ maxWidth: "55%", float: "left", position: "relative" }}>
                        <div style={{ display: "block" }}>
                          <h4>Assumptions</h4>
                          <ul style={{ lineHeight: "1.4em", paddingLeft: "1em" }}>{listItems}</ul>
                        </div>
                        <div style={{ position: "relative", display: "block" }}>
                          <h4>Material Health</h4>
                          <ul style={{ lineHeight: "1.4em", paddingLeft: "1em" }}>{listItemsHealth}</ul>
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}


            </span>
          </div>

            {this.props.type === SYSTEM_TYPE_FLOORING ? <div style={{ height: "700px" }}>

          </div> : null}
        </Dialog>
      </>
    )
  }
}

